module.exports = __webpack_public_path__ + "static/img/14000114.cd1def02.png";